import { Component } from "preact";
import { connect } from "preact-redux";
import style from "./style.scss";

import YesNoButton from "./Button";
import { Button } from "/chat/src/components/Buttons";
import SendButton from "/chat/src/components/SVGImages/SendButton";

import CustomizationModel from "/chat/src/redux/model/customization/model";
import FeedbackModel from "/chat/src/redux/model/feedback/model";
import FeedbackStorage from "/chat/src/lib/LocalStorage/Feedback";
import SVG from "react-inlinesvg";

class Feedback extends Component {
  constructor(props) {
    super(props);
    //hover: None == 0, Yes == 1, No == -1.
    this._setRef = this._setRef.bind(this);
    this.onClickSend = this.onClickSend.bind(this);
    this._handleRequest = this._handleRequest.bind(this);
    this._onChange = this._onChange.bind(this);
    this.state = {
      hover: 0,
      selected: 0,
      conisent: false,
      input: "",
      isVotable: "",
    };
  }

  _renderSmiley() {
    const { hover, selected } = this.state;
    if (selected === 1)
      return (
        <SVG
          className={style.FeedbackIcon}
          src={"/common/assets/images/FeedbackHappy.svg"}
          style={{ fill: "#86d677" }}
        />
      );
    if (hover === -1 || selected === -1)
      return (
        <SVG
          className={style.FeedbackIcon}
          src={"/common/assets/images/FeedbackNegative.svg"}
          style={{ fill: "#ff6d67" }}
        />
      );
    if (hover === 1)
      return (
        <SVG
          className={style.FeedbackIcon}
          src={"/common/assets/images/FeedbackPositive.svg"}
          style={{ fill: "#86d677" }}
        />
      );

    if (hover === 0 || selected === 0)
      return (
        <SVG
          className={style.FeedbackIcon}
          src={"/common/assets/images/FeedbackNeutral.svg"}
          style={{ fill: "#bababa" }}
        />
      );
  }

  _handleRequest(payload) {}

  _setRef(node) {
    this.feedbackInput = node;
  }

  componentDidMount() {
    this.setState({
      isVotable: FeedbackStorage.isVoteable(
        this.props.articleId,
        this.props.dateModified
      ),
    });
  }

  componentDidUpdate(prevProps, prevState) {
    const { selected } = this.state;
    if (prevState.selected !== -1 && selected === -1) {
      this.feedbackInput.scrollIntoView();
    }

    if (this.props !== prevProps) {
      this.setState({
        isVotable: FeedbackStorage.isVoteable(
          this.props.articleId,
          this.props.dateModified
        ),
      });
    }
  }

  _renderInput() {
    const { selected, input } = this.state;
    if (selected === -1) {
      const imgCmp = <SendButton color="white" />;
      return (
        <div>
          <div className={style.FeedbackTextInputContainer} ref={this._setRef}>
            <div className={style.FeedbackTextInputHelp}>
              Hjälp oss att bli bättre med din feedback.
            </div>
            <textarea
              rows="9"
              value={input}
              onChange={this._onChange}
              className={style.TextArea}
            >
              {" "}
            </textarea>
          </div>
          <div className={style.SendButtonWrapper}>
            <Button onClick={this.onClickSend} text="Skicka" imgCmp={imgCmp} />
          </div>
        </div>
      );
    }
    return null;
  }

  _onChange(e) {
    this.setState({ input: e.target.value });
  }

  onClickYesNo(selected) {
    const { articleId, dateModified } = this.props;

    this.setState({ selected: selected });

    if (selected === 1) {
      FeedbackStorage.addToVoted(articleId, dateModified, selected);
      FeedbackModel.sendFeedback(
        "helpdesk",
        articleId,
        this.state.input,
        this.state.selected,
        this._handleRequest
      );
    }

    if (selected === 1) {
      this.setState({ isVotable: false });
    }
  }

  onClickSend() {
    const { articleId, dateModified } = this.props;
    const { input, selected } = this.state;

    FeedbackModel.sendFeedback(
      "helpdesk",
      articleId,
      input,
      selected,
      this._handleRequest
    );
    FeedbackStorage.addToVoted(articleId, dateModified, selected);

    this.setState({ isVotable: false });
  }

  render() {
    const { selected, isVotable } = this.state;

    if (isVotable) {
      return (
        <div className={style.FeedbackContainer}>
          <div className={style.FeedbackSmiley}>
            <div className={style.FeedbackPromptText}>
              {this.props.language.get("WasThisArticleHelpful")}
            </div>
            <div className={style.FeedbackButtons}>
              <YesNoButton
                text={this.props.language.get("Yes")}
                color="#86d677"
                active={selected === 1}
                mouseEnter={() => this.setState({ hover: 1 })}
                mouseLeave={() => this.setState({ hover: 0 })}
                onClick={() => this.onClickYesNo(1)}
              />
              <div className={style.IconWrapper}>{this._renderSmiley()}</div>
              <YesNoButton
                text={this.props.language.get("No")}
                color="#ff6d67"
                active={selected === -1}
                mouseEnter={() => this.setState({ hover: -1 })}
                mouseLeave={() => this.setState({ hover: 0 })}
                onClick={() => this.onClickYesNo(-1)}
              />
            </div>
          </div>
          {this._renderInput()}
        </div>
      );
    } else {
      return (
        <div className={style.FeedbackThanks}>
          {this.props.language.get("ThankForFeedback")}
          <div className={style.ThanksIconWrapper}>
            <SVG
              className={style.FeedbackIcon}
              src={"/common/assets/images/FeedbackPositive.svg"}
              style={{ fill: "#86d677" }}
            />
          </div>
        </div>
      );
    }
  }
}

function mapStateToProps(state) {
  return {
    language: CustomizationModel.getLanguage(state),
  };
}

export default connect(mapStateToProps)(Feedback);



// WEBPACK FOOTER //
// ./routes/HelpDesk/HelpDeskArticle/Feedback/Feedback.js